export function getFormattedDates(specificDay = new Date()) {
  const todayMinus15Years = new Date(specificDay.getTime())
  const todayMinus150Years = new Date(specificDay.getTime())

  todayMinus15Years.setFullYear(specificDay.getFullYear() - 15)
  todayMinus150Years.setFullYear(specificDay.getFullYear() - 150)

  todayMinus150Years.setUTCHours(0, 0, 0, 0)

  return {
    TODAY: specificDay.toISOString(),
    TODAY_MINUS_15_YEARS: todayMinus15Years.toISOString(),
    TODAY_MINUS_150_YEARS: todayMinus150Years.toISOString(),
  }
}
